import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IAdvisoryTranchePaginatedResponse,
  getAdvisoryTranchePaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { AdvisoryTrancheModalMode } from "./enums";
import { IAdvisoryTrancheModalData } from "./types";

const initialState = {
  advisoryTrancheData: null as Nullable<
    IAdvisoryTranchePaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: AdvisoryTrancheModalMode.VIEW,
    open: false,
    loading: false,
  } as IAdvisoryTrancheModalData,
};

export const fetchAdvisoryTrancheList = createAsyncThunk(
  "advisory/fetchAdvisoryTrancheList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getAdvisoryTranchePaginated(filters);
    return response;
  }
);

const advisoryTrancheSlice = createSlice({
  name: "advisoryTranche",
  initialState,
  reducers: {
    setAdvisoryTrancheModalData: (
      state,
      action: PayloadAction<IAdvisoryTrancheModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeAdvisoryTrancheModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setAdvisoryTrancheModalLoading: (state, action: PayloadAction<boolean>) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdvisoryTrancheList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        advisoryTrancheData: action.payload
          ?.edges as IAdvisoryTranchePaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchAdvisoryTrancheList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setAdvisoryTrancheModalData,
  closeAdvisoryTrancheModal,
  setAdvisoryTrancheModalLoading,
} = advisoryTrancheSlice.actions;

export default advisoryTrancheSlice.reducer;
